import { HttpContextToken } from '@angular/common/http';

/** Evita sign-out y recarga de página ante 401 (p. ej. callback OAuth Ping ID). */
export const SKIP_AUTH_UNAUTHORIZED_RELOAD = new HttpContextToken<boolean>(
    () => false
);
